import { Component, OnInit } from '@angular/core';
import { BpgMembershipService } from '../bpg-membership.service';
import { DataService, bpgs, interests, skills, membershipFormData, leadership, site } from "../../bpg-common/services/data.services";
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';

import { Router } from '@angular/router';
import { EnvironmentConfiguration } from 'src/app/environment/services/environment.configuration';
import { ConstantValues } from 'src/app/bpg-common/models/bpg-constants';

@Component({
  selector: 'app-bpg-skill-list',
  templateUrl: './bpg-skill-list.component.html',
  styleUrls: ['./bpg-skill-list.component.css']
})
export class BpgSkillListComponent implements OnInit {

  skillsList: any[] = [];
  savedData: any;
  interestList: any[];
  bpgList: any[];
  siteList: site;
  selectedSkills: any[] = [];
  formData: membershipFormData[];
  leadershipList: leadership = new leadership();
  demographicsList: any[] = [];
  otherSKills: string;
  savedMembershipForm: any;
  timeOutError: boolean;
  timeoutErrorMessage: string = ConstantValues.timeoutErrorMessage;

  login_data: any;
  corporateType: string;
  isCorporateUser: boolean = false;

  /** @class BpgSkillListComponent
  * @constructor
  */
  constructor(private membershipService: BpgMembershipService, private data: DataService, private spinnerService: Ng4LoadingSpinnerService,  private router: Router, private environment: EnvironmentConfiguration) { }

  ngOnInit() {
    if (this.environment.envName == 'dev' || this.environment.envName == 'qa' || this.environment.envName == 'prod') {
              if (localStorage.getItem('loginData')== null || localStorage.getItem('loginData')== undefined) {

        this.router.navigate(['/log-out']);
      }
    }

    this.formData = [];
    //this.data.savedData.subscribe(savedData => this.savedData = savedData)
    //this.data.savedMembershipForm.subscribe(savedMembershipForm => this.savedMembershipForm = savedMembershipForm)
    this.savedMembershipForm = JSON.parse(sessionStorage.getItem('previousMembershipDetails'));
    this.savedData = JSON.parse(sessionStorage.getItem('MembershipData'));

    this.login_data = (localStorage.getItem('loginData')) ? JSON.parse(localStorage.getItem('loginData')) : '';
    this.corporateType = (this.login_data.corporatePartnerType !== null && this.login_data.corporatePartnerType !== undefined) ? this.login_data.corporatePartnerType.trim() : '';
    if (this.corporateType.toUpperCase() == "CONTINGENT" || this.corporateType.toUpperCase() == "TECHNICAL CONTRACTOR") {
      this.isCorporateUser = true;
    }

    this.spinnerService.show();
    if (this.savedData[0].interestFormData != undefined) {
      this.interestList = this.savedData[0].interestFormData;
    } else {
      this.interestList = [];
    }
    if (this.savedData[0].bpgFormData != undefined) {
      this.bpgList = this.savedData[0].bpgFormData;
    } else {
      this.bpgList = [];
    } if (this.savedData[0].siteFormData != undefined) {
      this.siteList = this.savedData[0].siteFormData;
    } else {
      this.siteList = null;
    }
    // demographic code comment
    // if (this.savedData[0].demographicsFormData != undefined) {
    //   this.demographicsList = this.savedData[0].demographicsFormData;
    // } else {
    //   this.demographicsList = [];
    // }
    if (this.savedData[0].leadershipFormData != undefined) {
      this.leadershipList = this.savedData[0].leadershipFormData;
    } else {
      this.leadershipList = null;
    }
    if (this.savedData[0].otherSkillsFormData != undefined) {
      this.otherSKills = this.savedData[0].otherSkillsFormData;
    } else {
      this.otherSKills = null;
    }

    this.membershipService.getSkills().subscribe(data => {
      this.timeOutError = false;
      this.skillsList = data;
      this.spinnerService.hide();
      if (this.savedData[0].skillsFormData != undefined) {
        if (this.savedData[0].skillsFormData.length > 0) {
          for (let i = 0, len = this.skillsList.length; i < len; i++) {
            for (let j = 0, len = this.savedData[0].skillsFormData.length; j < len; j++) {
              if (this.skillsList[i].skillId == this.savedData[0].skillsFormData[j].skillId) {
                this.skillsList[i].checked = true;
                this.selectedSkills.push(this.skillsList[i]);
              }
            }
          }
        } else if (localStorage.getItem('oneSkill') == 'true') {
          if (this.savedMembershipForm.otherSkills != this.savedData[0].otherSkillsFormData) {
            this.otherSKills = this.savedData[0].otherSkillsFormData;
          } else {
            this.otherSKills = this.savedMembershipForm.otherSkills;
          }
          this.selectedSkills.push(this.savedData[0].skillsFormData);
        }
        else if (this.savedMembershipForm.skillIds.length > 0) {
          if (this.savedMembershipForm.otherSkills != null) {
            this.otherSKills = this.savedMembershipForm.otherSkills;
          }
          for (let i = 0, len = this.skillsList.length; i < len; i++) {
            for (let j = 0, len = this.savedMembershipForm.skillIds.length; j < len; j++) {
              if (this.skillsList[i].skillId == this.savedMembershipForm.skillIds[j]) {
                this.skillsList[i].checked = true;
                this.selectedSkills.push(this.skillsList[i]);
              }
            }
          }
        }
        else if (this.savedMembershipForm.otherSkills != null) {
          this.otherSKills = this.savedMembershipForm.otherSkills;
        }
      }

    }, err => {
      this.spinnerService.hide();
      console.log(JSON.stringify(err.value.message));
      if (err.value.statusText == ConstantValues.unknownError) {
        this.timeOutError = true;
      }
    });
  }

  /** to select the checkbox
   * @class BpgSkillListComponent
   * @method toggleCheckbox
   */
  toggleCheckbox(event, data) {
    if (event.target.checked) {
      this.selectedSkills.push(data);
      localStorage.setItem('oneSkill', 'false');
    } else {
      const index: number = this.selectedSkills.indexOf(data);
      if (index !== -1) {
        this.selectedSkills.splice(index, 1);
        localStorage.setItem('oneSkill', 'true');
      }
    }
  }

  /** To send data to next page
     * @class BpgSkillListComponent
     * @method saveData
     */
  public saveData() {
    this.formData.push({ virtualBpg: this.savedData[0].virtualBpg, siteFormData: this.siteList, bpgFormData: this.bpgList, interestFormData: this.interestList, skillsFormData: this.selectedSkills, leadershipFormData: this.leadershipList, otherSkillsFormData: this.otherSKills });
    //demographic code comment
    // this.formData.push({ bpgFormData: this.bpgList, interestFormData: this.interestList, skillsFormData: this.selectedSkills, leadershipFormData: this.leadershipList, demographicsFormData: this.demographicsList, otherSkillsFormData: this.otherSKills });
    //this.data.saveData(this.formData);
    sessionStorage.setItem("MembershipData", JSON.stringify(this.formData));
    window.scrollTo(0, 0)
  }

  /** To send data to previous page
     * @class BpgSkillListComponent
     * @method redirectToBpg
     */
  public redirectToBpg() {
    this.formData.push({ virtualBpg: this.savedData[0].virtualBpg, siteFormData: this.siteList, bpgFormData: this.bpgList, interestFormData: this.interestList, skillsFormData: this.selectedSkills, leadershipFormData: this.leadershipList, otherSkillsFormData: this.otherSKills });
    // demographic code comment
    //this.formData.push({ bpgFormData: this.bpgList, interestFormData: this.interestList, skillsFormData: this.selectedSkills, leadershipFormData: this.leadershipList, demographicsFormData: this.demographicsList, otherSkillsFormData: this.otherSKills });
    //this.data.saveData(this.formData);
    sessionStorage.setItem("MembershipData", JSON.stringify(this.formData));
    window.scrollTo(0, 0)
  }

  /**skips the selected data and goes to next page
    * @class BpgSkillListComponent
    * @method skipSkills
    */
  public skipSkills() {
    this.formData.push({ virtualBpg: this.savedData[0].virtualBpg, siteFormData: this.siteList, bpgFormData: this.bpgList, interestFormData: this.interestList, skillsFormData: [], leadershipFormData: this.leadershipList, otherSkillsFormData: null });
    //demographic code comment
    //this.formData.push({ bpgFormData: this.bpgList, interestFormData: this.interestList, skillsFormData: [], leadershipFormData: this.leadershipList, demographicsFormData: this.demographicsList, otherSkillsFormData: null });
    //this.data.saveData(this.formData);
    sessionStorage.setItem("MembershipData", JSON.stringify(this.formData));
    window.scrollTo(0, 0)
  }

  /**skips the selected data and goes to next page
   * @class BpgLeadershipComponent
   * @method skipLeadership
   */
  public skipLeadership() {
    this.formData.push({ virtualBpg: this.savedData[0].virtualBpg, siteFormData: this.siteList, bpgFormData: this.bpgList, interestFormData: this.interestList, skillsFormData: this.skillsList, leadershipFormData: null, otherSkillsFormData: this.otherSKills });
    sessionStorage.setItem("MembershipData", JSON.stringify(this.formData));
    window.scrollTo(0, 0)
  }
}
